import { render, staticRenderFns } from "./ModattaLandingHowItWorks.vue?vue&type=template&id=7de6e7a2"
import script from "./ModattaLandingHowItWorks.vue?vue&type=script&lang=js"
export * from "./ModattaLandingHowItWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports